if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      this.initNavButtons();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        this.updateQuantitySelectorVisibility();
      }

      this.initNavButtons();
      this.setVariantMetafields();
    }

    updateQuantitySelectorVisibility() {
      const quantityWrapper = document.getElementById(`Quantity-Wrapper-${this.dataset.section}`);
      if (!quantityWrapper) return;

      const digitalSkuPrefix = quantityWrapper.dataset.digitalSkuPrefix;
      const isDigitalVariant = digitalSkuPrefix && this.currentVariant.sku && this.currentVariant.sku.startsWith(digitalSkuPrefix);

      quantityWrapper.hidden = !!isDigitalVariant;

      if (isDigitalVariant) {
        const quantityInput = quantityWrapper.querySelector('.quantity__input');
        if (quantityInput) quantityInput.value = 1;
      }
    }

    initNavButtons() {
      const prevImageButton = document.querySelector('.nav-btn-prev')
      const nextImageButton = document.querySelector('.nav-btn-next')
      const thumbnailList = document.querySelector('.thumbnail-list')
      const currentImage = thumbnailList?.querySelector('button[aria-current="true"]')
      if(prevImageButton && nextImageButton && thumbnailList && currentImage && window.innerWidth >= 750) {
        const nextListElement = currentImage.parentElement.nextElementSibling
        const prevListElement = currentImage.parentElement.previousElementSibling
        if(!prevListElement) {
          prevImageButton.classList.add('hidden')
        } else {
          prevImageButton.classList.remove('hidden')
        }
        if(!nextListElement) {
          nextImageButton.classList.add('hidden')
        } else {
          nextImageButton.classList.remove('hidden')
        }
      }
    }

    setVariantMetafields() {
      const variantMetafieldBlocks = document.querySelectorAll('.product-variant-metafields')
      variantMetafieldBlocks.forEach((block) => {
        if(block.dataset.variantTitle === this.currentVariant.title) {
          block.classList.add('product-variant-metafields--active')
        } else {
          block.classList.remove('product-variant-metafields--active')
        }
      })
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const activeElementId = document.activeElement.id;
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const variantPickerDestination = document.getElementById(`variant-radios-${this.dataset.section}`) || document.getElementById(`variant-selects-${this.dataset.section}`);
          const variantPickerSource = html.getElementById(`variant-radios-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`) || html.getElementById(`variant-selects-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;

          const price = document.getElementById(`price-${this.dataset.section}`);

          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

          document.querySelector('variant-radios') ? this.querySelector(`[for="${activeElementId}"]`).focus() : this.querySelector(`#${activeElementId}`).focus();
        });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

const productFormDiv = document.querySelector('product-form')

if (productFormDiv) {
  const productForm = productFormDiv.querySelector('form')
  const productFormSubmit = productForm.querySelector('button')
  const addToCartSubmitButtons = document.querySelectorAll('.add-to-cart-submit-btn')
  if(addToCartSubmitButtons) {
    addToCartSubmitButtons.forEach((button) => {
      if(productFormSubmit.firstElementChild.innerHTML.includes('Sold out')) {
        button.innerHTML = 'Sold out'
        button.style.display = 'none'
      } else {
        button.addEventListener('click', (event) => {
          productFormSubmit.click()
        })
      }
    })
  }
}
